import React from "react";

const Portfolio = () => {
  return (
    <div className="page pt-portfolio" data-simplebar="">
      <section className="container">
        {/* Section Title */}
        <div className="header-page mt-70 mob-mt">
          <h2>Portfolio</h2>
          <span></span>
        </div>

        {/* Portfolio Filter Row Start */}
        <div className="row mt-100">
          <div className="col-lg-12 col-sm-12 portfolio-filter">
            <ul>
              <li className="active" data-filter="*">
                All
              </li>
              <li data-filter=".application">Application</li>
              <li data-filter=".website">Website</li>
            </ul>
          </div>
        </div>

        {/* Portfolio Item Row Start */}
        <div className="row portfolio-items mt-100 mb-100">
          {/* Portfolio Item  */}
          <div className="item col-lg-4 col-sm-6 application">
            <figure>
              <h4 className="p-1 pl-2">Virtual SU</h4>
              <img
                alt=""
                src="https://1.bp.blogspot.com/-4Kn927umMHs/YVyPGpbgDiI/AAAAAAAAaZI/j2kSrbs8Vg0wFDzLywdWLcLjTAKPouYowCLcBGAsYHQ/s2160/img-1.png"
              />
              <figcaption>
                <p>Virtual Plateform For Students</p>
                <i className="fas fa-video"></i>
                <a
                  className="video-link"
                  href="https://www.youtube.com/watch?v=Sk0rzBQburo"
                >
                  {" "}
                </a>  
              </figcaption>
            </figure>
          </div>

          {/* Portfolio Item  */}
          <div className="item col-lg-4 col-sm-6 application">
            <figure>
              <h4 className="p-1 pl-2">Easy Way Banking</h4>
              <img
                alt=""
                src="https://1.bp.blogspot.com/-WIpbAxPCwPc/YVyPBMp0eJI/AAAAAAAAaY4/3dQJnhm5iSwT2WukqyWWXt2L_RbuOiKpgCLcBGAsYHQ/s2160/img-2.png"
              />
              <figcaption>
                <p>Banking Solutions</p>
                <i className="fas fa-image"></i>
                <a
                  className="image-link"
                  href="https://1.bp.blogspot.com/-WIpbAxPCwPc/YVyPBMp0eJI/AAAAAAAAaY4/3dQJnhm5iSwT2WukqyWWXt2L_RbuOiKpgCLcBGAsYHQ/s2160/img-2.png"
                >
                  {" "}
                </a>
              </figcaption>
            </figure>
          </div>

          {/* Portfolio Item  */}
          <div className="item col-lg-4 col-sm-6 application">
            <figure>
              <h4 className="p-1 pl-2">Ecommerce Application</h4>
              <img
                alt=""
                src="https://1.bp.blogspot.com/-FwMRgvHpCGs/YVyPCDAgXaI/AAAAAAAAaY8/crwgeCx-d8UTxV0JKTQZc05bDaAdggu2ACLcBGAsYHQ/s800/img-3.png"
              />
              <figcaption>
                <p>Ecommerce Application</p>
                <i className="fas fa-image"></i>
                <a
                  className="image-link"
                  href="https://1.bp.blogspot.com/-FwMRgvHpCGs/YVyPCDAgXaI/AAAAAAAAaY8/crwgeCx-d8UTxV0JKTQZc05bDaAdggu2ACLcBGAsYHQ/s800/img-3.png"
                >
                  {" "}
                </a>
              </figcaption>
            </figure>
          </div>

          {/* Portfolio Item  */}
          <div className="item col-lg-4 col-sm-6 application">
            <figure>
              <h4 className="p-1 pl-2">Talents Root</h4>
              <img
                alt=""
                src="https://1.bp.blogspot.com/-R3zYWUjkyUM/YVyPDSvyXTI/AAAAAAAAaZA/-Y_Dj_y0rTcciriKhxH84I8twhtztGltQCLcBGAsYHQ/s2160/img-4.jpg"
              />
              <figcaption>
                <p>React Native Application</p>
                <i className="fas fa-image"></i>
                <a
                  className="image-link"
                  href="https://1.bp.blogspot.com/-R3zYWUjkyUM/YVyPDSvyXTI/AAAAAAAAaZA/-Y_Dj_y0rTcciriKhxH84I8twhtztGltQCLcBGAsYHQ/s2160/img-4.jpg"
                >
                  {" "}
                </a>
              </figcaption>
            </figure>
          </div>

          {/* Portfolio Item  */}
          <div className="item col-lg-4 col-sm-6 website">
            <figure>
              <h4 className="p-1 pl-2">PSD To HTML</h4>
              <img
                alt=""
                src="https://1.bp.blogspot.com/-BCclzQPawf8/YVyPGfKXdLI/AAAAAAAAaZE/dixccjY6F5APJZzY49XuiWUPyVfFLfRnwCLcBGAsYHQ/s2048/img-5.jpg"
              />
              <figcaption>
                <p>Psd to html conversion</p>
                <i className="fas fa-image"></i>
                <a
                  className="image-link"
                  href="https://1.bp.blogspot.com/-BCclzQPawf8/YVyPGfKXdLI/AAAAAAAAaZE/dixccjY6F5APJZzY49XuiWUPyVfFLfRnwCLcBGAsYHQ/s2048/img-5.jpg"
                >
                  {" "}
                </a>
              </figcaption>
            </figure>
          </div>

          {/* Portfolio Item  */}
          <div className="item col-lg-4 col-sm-6 website">
            <figure>
              <h4 className="p-1 pl-2">MERN Stack Projects</h4>
              <img
                alt=""
                src="https://1.bp.blogspot.com/-pYOmU-hBrKg/YVyPHB8ndRI/AAAAAAAAaZM/ndrk87RTcOoN52epW4Yw6sz0xZXvWscKACLcBGAsYHQ/s2160/img-6.png"
              />
              <figcaption>
                <div>
                  <a
                    target="blank"
                    href="https://docs.google.com/document/d/178_dedZi1VrQz2BhnPikizshxHfadLlIycaFoI38esE/edit?usp=sharing"
                  >
                    <p style={{ color: "white" }}>See My MERN Stack projects</p>
                    <i className="fas fa-file" style={{ color: "white" }}></i>
                  </a>
                </div>
              </figcaption>
            </figure>
          </div>

          {/* Portfolio Item  */}
          <div className="item col-lg-4 col-sm-6 website">
            <figure>
              <h4 className="p-1 pl-2">React Website</h4>
              <img
                alt=""
                src="https://1.bp.blogspot.com/-SAQrLWmlR18/YVyPTct5ziI/AAAAAAAAaZg/ZXeiPnzEh0MAZcY7f2Gic__VQkt4YjsuwCLcBGAsYHQ/s1366/img-8.png"
              />
              <figcaption>
                <div>
                  <a target="blank" href="https://briotapaper.com/">
                    <p style={{ color: "white" }}>
                      Website built with React.js
                    </p>
                    <i style={{ color: "white" }} className="fas fa-globe"></i>
                  </a>
                </div>
              </figcaption>
            </figure>
          </div>

          {/* Portfolio Item  */}
          <div className="item col-lg-4 col-sm-6 website">
            <figure>
              <h4 className="p-1 pl-2">Reusable React Components</h4>
              <img
                alt=""
                src="https://1.bp.blogspot.com/-o2GI3XIpWiE/YVyPU9BDoRI/AAAAAAAAaZk/j8bs0D8iAy0nGLllJaxY1uruCshrvQCHgCLcBGAsYHQ/s2048/img-9.jpg"
              />
              <figcaption>
                <p>I can create Reusable Components</p>
                <i className="fas fa-video"></i>
                <a
                  className="video-link"
                  href="https://www.youtube.com/watch?v=EAkSHborY4s"
                >
                  {" "}
                </a>
              </figcaption>
            </figure>
          </div>

          {/* Portfolio Item  */}
          <div className="item col-lg-4 col-sm-6 website">
            <figure>
              <h4 className="p-1 pl-2">Final year project</h4>
              <img
                alt=""
                src="https://1.bp.blogspot.com/-64YTXpelwyE/YVyPTPg86KI/AAAAAAAAaZc/1Kc6fWqKbYUt039yqsHMWDBCX0TNrkc8wCLcBGAsYHQ/s1366/img-7.png"
              />
              <figcaption>
                <p>Student Info site</p>
                <i className="fas fa-video"></i>
                <a
                  className="video-link"
                  href="https://www.youtube.com/watch?v=TvJRQqSpzP4"
                >
                  {" "}
                </a>
              </figcaption>
            </figure>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Portfolio;
